import React from 'react';
import { createPortal } from 'react-dom';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

export function Lightbox({ photos, index, setIndex, onClose }) {
  React.useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prevOverflow; };
  }, []);
  React.useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') setIndex(i => (i + 1) % photos.length);
      if (e.key === 'ArrowLeft') setIndex(i => (i - 1 + photos.length) % photos.length);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [photos.length, onClose, setIndex]);
  const touchX = React.useRef(null);
  const onTouchStart = (e) => { touchX.current = e.touches[0].clientX; };
  const onTouchEnd = (e) => {
    if (touchX.current == null) return;
    const dx = e.changedTouches[0].clientX - touchX.current;
    if (dx > 40) setIndex(i => (i - 1 + photos.length) % photos.length);
    else if (dx < -40) setIndex(i => (i + 1) % photos.length);
    touchX.current = null;
  };
  return createPortal(
    <div className="lightbox-backdrop" data-testid="image-lightbox" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <button className="lightbox-close" onClick={onClose} data-testid="lightbox-close-btn" aria-label="Close"><X size={20} /></button>
      <div className="lightbox-stage" onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
        {photos.length > 1 && <button className="lightbox-nav prev" onClick={() => setIndex(i => (i - 1 + photos.length) % photos.length)} data-testid="lightbox-prev-btn" aria-label="Previous"><ChevronLeft size={26} /></button>}
        <img src={photos[index]} alt="" data-testid="lightbox-image" />
        {photos.length > 1 && <button className="lightbox-nav next" onClick={() => setIndex(i => (i + 1) % photos.length)} data-testid="lightbox-next-btn" aria-label="Next"><ChevronRight size={26} /></button>}
      </div>
      {photos.length > 1 && (
        <div className="lightbox-dots">
          {photos.map((_, i) => <span key={i} className={i === index ? 'active' : ''} onClick={() => setIndex(i)} />)}
        </div>
      )}
    </div>,
    document.body
  );
}

export function ImageGallery({ photos = [], alt = '', testId = 'gallery' }) {
  const [index, setIndex] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const touchX = React.useRef(null);
  if (!photos.length) return null;
  const onTouchStart = (e) => { touchX.current = e.touches[0].clientX; };
  const onTouchEnd = (e) => {
    if (touchX.current == null) return;
    const dx = e.changedTouches[0].clientX - touchX.current;
    if (dx > 40) setIndex(i => (i - 1 + photos.length) % photos.length);
    else if (dx < -40) setIndex(i => (i + 1) % photos.length);
    touchX.current = null;
  };
  return (
    <>
      <div className="benefit-gallery" data-testid={testId}>
        <div className="benefit-gallery-stage" onTouchStart={onTouchStart} onTouchEnd={onTouchEnd} onClick={() => setOpen(true)} data-testid={`${testId}-open`}>
          <img src={photos[index]} alt={alt} />
        </div>
        {photos.length > 1 && (
          <div className="benefit-gallery-dots">
            {photos.map((_, i) => <span key={i} className={i === index ? 'active' : ''} onClick={(e) => { e.stopPropagation(); setIndex(i); }} />)}
          </div>
        )}
      </div>
      {open && <Lightbox photos={photos} index={index} setIndex={setIndex} onClose={() => setOpen(false)} />}
    </>
  );
}
